import media from './media';
import myCars from './myCars';
import widgetInfo from './widgetInfo';
import modalSettings from './modalSettings';
import renderSettings from './renderSettings';

const root = {
	media,
	myCars,
	widgetInfo,
	modalSettings,
	renderSettings
};

export default root;



// WEBPACK FOOTER //
// ./src/reducers/index.js